import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'
import {InputText} from '@/components/commons/input-text/InputText'
import {TextArea} from '@/components/commons/textarea/TextArea'

export const StyledNewConversationForm = styled.form`
    display: flex;
    width: 100%;
`

export const StyledNewConversationFormInputsContainer = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral.white};
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        padding-bottom: ${spacing * 2}px;
    `
)

export const StyledNewConversationInputText = styled(InputText)<{inputSize?: 'sm' | 'md' | 'lg'}>(
    ({theme: {typography}}) => css`
        & > input {
            ${typography.textXs};
        }
        & div {
            box-shadow: none !important;
            outline: none !important;
        }
    `
)

export const StyledNewConversationTextArea = styled(TextArea)(
    ({theme: {typography, spacing}}) => css`
        height: 100%;

        & textarea {
            padding: ${spacing * 2}px;
            ${typography.textXs};
        }

        & div {
            height: 100%;
            border: none !important;
            box-shadow: none !important;
            outline: none !important;
        }
    `
)

export const StyledNewConversationFormFooter = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 3}px ${spacing * 2}px 0;
        margin-top: ${spacing * 2}px;
    `
)

export const StyledUrgentButton = styled(Button)<{$isActive?: boolean}>(
    ({theme: {palette}, $isActive}) => css`
        color: ${$isActive ? palette.warning[600] : palette.neutral[500]};
        &:hover {
            color: ${$isActive ? palette.warning[700] : palette.warning[600]};
        }
    `
)

export const StyledParticipantsInputContainer = styled.div(
    () => css`
        position: relative;
        width: 100%;
    `
)

export const StyledParticipantsDisplay = styled(Button)(
    ({theme: {typography, spacing, palette, borderRadius}}) => css`
        ${typography.textXs};
        min-height: 40px;
        padding: ${spacing * 2}px;
        border-radius: ${borderRadius}px;
        background-color: ${palette.neutral.white};
        color: ${palette.neutral[900]};
        cursor: pointer;
        gap: ${spacing * 1.5}px;
        justify-content: flex-start;
        width: 100%;
        display: flex;
        align-items: center;

        & svg {
            color: ${palette.neutral[500]};
        }

        &:hover {
            background-color: ${palette.neutral[50]};
        }

        &:focus {
            background-color: ${palette.neutral.white};
        }
    `
)

export const StyledParticipantsText = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[500]};
        &.has-selection {
            color: ${palette.neutral[900]};
        }
    `
)

export const StyledParticipantsAvatars = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        align-items: center;
        gap: -${spacing}px; /* Negative gap for overlapping avatars */
        flex-shrink: 0;
    `
)

export const StyledAddParticipantButton = styled(Button)(
    ({theme: {spacing}}) => css`
        position: absolute;
        right: ${spacing}px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
    `
)
